// tslint:disable:max-line-length

import React from 'react';

export const EditorLink = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.9,5.4C9.3,4.8,8.5,4.4,7.6,4.5c-0.8,0-1.5,0.4-2.1,0.9L0.9,10c-0.6,0.6-1,1.4-0.9,2.3c0,0.8,0.4,1.5,0.9,2.1l0.7,0.7 C2.2,15.7,3,16,3.9,16c0,0,0,0,0.1,0c0.8,0,1.5-0.4,2.1-0.9l1.6-1.6l-1.2-1.2l-1.6,1.6c-0.5,0.5-1.4,0.5-1.9,0l-0.7-0.7 c-0.5-0.5-0.5-1.4,0-1.9l4.6-4.6c0.5-0.5,1.4-0.5,1.9,0l0.7,0.7l1.3-1.3L9.9,5.4z" />
      <path d="M15.1,1.6l-0.7-0.7C13.8,0.3,13,0,12.1,0c0,0,0,0-0.1,0c-0.8,0-1.5,0.4-2.1,0.9L8.5,2.5l1.2,1.2l1.6-1.6 c0.5-0.5,1.4-0.5,1.9,0l0.7,0.7c0.5,0.5,0.5,1.4,0,1.9L9.4,9.4C8.8,10,8,10,7.5,9.4L6.7,8.6L5.4,9.9l0.7,0.7 c0.6,0.6,1.4,0.9,2.2,0.9c0,0,0,0,0.1,0c0.8,0,1.5-0.4,2.1-0.9L15.1,6c0.6-0.6,1-1.4,0.9-2.3C16,2.9,15.6,2.2,15.1,1.6z" />
    </svg>
  );
};
